/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function FilterIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M4 8.625C4 7.188 5.125 6 6.563 6h26.812A2.64 2.64 0 0 1 36 8.625c0 .625-.25 1.188-.625 1.625L25 23.063V32c0 1.125-.937 2-2.062 2a1.9 1.9 0 0 1-1.25-.437L15.938 29A2.42 2.42 0 0 1 15 27.063v-4L4.563 10.25C4.188 9.813 4 9.25 4 8.625M7.438 9l10.187 12.563q.375.469.375.937v4.313L22 30v-7.5c0-.312.063-.625.313-.937L32.563 9z"/>}
        </IconWrapper>);
}
